export const MOBILE_VIEW_UNTIL_WIDTH = 799;
export const DESKTOP_VIEW_FROM_WIDTH = 800;
